type CardHolderProps = {
    name?: string
    first_name?: string
    last_name?: string
}
export default ({ name, first_name, last_name }: CardHolderProps = {}) => name ? name : (first_name || last_name ? `${first_name} ${last_name}` : '')